import React from 'react';
import s from './Footer.module.scss';
import i18n from 'i18next';
const URL_SUBSCRIBE = "https://prover.io/order.php";

export default class Subscribe extends React.Component {
  state = {
    form: {
      email: '',
    },
    subscribeInfo: 'subscribe_info',
    showBtnSubmit: true,
  };

  subscribeSend = () => {
    const email = this.state.form.email;

    if (!this.validateEmail(email)) {
      this.setState({
        subscribeInfo: 'email_err'
      });
      return;
    }

    const lang = i18n.language === 'vi' ? 'vn' : i18n.language;

    const init = {
      method: 'POST',
      body: `email=${email}&lang=${lang}`,
      headers: {
        'Content-Type' : 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      credentials: 'omit'
    };

    this.setState({
      showBtnSubmit: false,
    });
    
    fetch(URL_SUBSCRIBE, init)
    .then(response => response.json())
    .then(data => {
        const res = data.result ? JSON.parse(data.result) : false;
        if (data.already_exists || (res && res.response.msg.err_code == 10)) {
          this.setState({
            subscribeInfo: 'already_exists_subscribed',
            showBtnSubmit: true,
          });
        } else {
          this.setState({
            subscribeInfo: 'successfully_subscribed',
            showBtnSubmit: false,
          });
      }
    })
    .catch((err) => {
      console.log(err);
    });
  }

  validateEmail = email => {
    const reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    return reg.test(email);
  }

  handleChangeField = ({ target }) => {
    const { form } = this.state;
    const value =  target.value;
    this.setState({ form: { ...form, [target.name]: value } });
  }

  render() {
    const { t } = this.props;
    const { form } = this.state;

    return (
      <div className={s.subscribe}>
        <div className={s.input}>
        <input type="hidden" name="lang" value="en" autocomplete="off" />
          <input
              type="text"
              name="email"
              onChange={this.handleChangeField}
              value={form.email}
              placeholder="Email"
            />
          { this.state.showBtnSubmit ? 
          <button onClick={this.subscribeSend} type="submit">
            {t('subscribe')}
          </button> :
          null }
        </div>
        <p dangerouslySetInnerHTML={{__html: t(this.state.subscribeInfo)}} />
        <a 
          className={s.privacy_policy}
          href="https://prover.io/assets/Privacy_Policy_ENG.pdf"
          target="_blank"
          rel="noopener noreferrer"
        > 
          {t('privacy_policy')}
        </a>
      </div>
    );
  }
}
